import { SeasonFragment, SeasonLeagueFragment } from '@amf/shared/types/graphql';
import useMatches, { MatchFilter, MatchSortOrder } from '@amf/shared/data/hooks/useMatches';
import Loader from '@amf/shared/components/utils/Loader';
import MatchTable from '@amf/shared/components/match/MatchTable';
import { useTranslate } from '@tolgee/react';
import { LeaguePhaseType } from '@amf/shared/data/League';

interface LeagueMatchesProps {
  season: SeasonFragment;
  league: SeasonLeagueFragment;
  prefixes: {
    team: string;
    match: string;
  };
  filter?: MatchFilter;
  type?: LeaguePhaseType;
}

function LeagueMatches({ season, league, prefixes, filter, type }: LeagueMatchesProps) {
  const { t } = useTranslate();
  const { matches, loading, loadMore } = useMatches(season.id, league.id, filter ?? null);

  if (loading) {
    return <Loader>{t('match.loading')}</Loader>;
  }

  return (
    <div className='Table'>
      <MatchTable
        matches={matches}
        matchPrefix={prefixes.match}
        type={type}
        noRounds={filter.sortBy === 'time'}
      />
      <div className='Table__pagination'>{loadMore()}</div>
    </div>
  );
}

export default LeagueMatches;
